import action from './action';

export default action;
